var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function CasinoResponseFormatter(response) {
    return __awaiter(this, void 0, void 0, function* () {
        let json;
        try {
            json = yield response.json();
        }
        catch (_a) {
            json = {};
        }
        if (!response.ok) {
            const errorResponse = json; // categories and games
            const baseErrorResponse = json; // launch and free spins
            throw new Error(`Error getting response: ${errorResponse.description || baseErrorResponse.message || response.status}`);
        }
        return json;
    });
}
//# sourceMappingURL=CasinoResponseFormatter.js.map